import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "main-content" };
const _hoisted_2 = { class: "card-section-wrapper" };
const _hoisted_3 = { class: "option-ctrl-area" };
const _hoisted_4 = {
    key: 0,
    class: "d-flex pb-4 justify-space-between align-center"
};
const _hoisted_5 = {
    key: 1,
    class: "d-flex pb-4 justify-space-between align-center"
};
const _hoisted_6 = { class: "input-content-wrapper" };
const _hoisted_7 = {
    "no-gutters": "",
    class: "mt-4 d-flex align-center justify-space-between"
};
import { ref, onBeforeUnmount, computed, watch, onMounted, } from 'vue';
import { routeName } from '@/constants/routeName';
import { createShareConfigFormData as createFormData } from '@/form/form-data';
import { errorCode, BusinessError, } from '@/error';
import { makeComponentInfoList } from '@/utils';
import { i18n } from '@/locales';
import createShareInfoConfigFormRules from '@/form/form-rules/shareManangement';
import ShareConfigBasic from '@V/ShareManagement/ShareConfig/ShareConfigBasic.vue';
import ShareConfigFeeRate from '@V/ShareManagement/ShareConfig/ShareConfigFeeRate.vue';
import SubscribeHubShareStoreListTable from '@V/ShareManagement/ShareConfig/SubscribeHubShareStoreListTable.vue';
import RegisteredShareStoreListTable from '@V/ShareManagement/ShareConfig/RegisteredShareStoreListTable.vue';
import CardSection from '@/components/Common/CardSection.vue';
import Select from '@/components/Form/Select.vue';
import searchFieldOptionList from '@/constants/shareManagement/searchFieldOptionList';
import { useRoute, useRouter, } from 'vue-router';
import shareStoreTableType from '@/constants/shareManagement/shareStoreTableType';
import { CanceledError } from 'axios';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { objDeepCompare } from '@/utils/object';
import vuexStore from '@/vuex-store';
import { shareConfigActionType } from '@/vuex-store/share-management/share-config/actions';
import { shareConfigGetterType } from '@/vuex-store/share-management/share-config/getters';
import SearchInput from '@/components/Form/SearchInput.vue';
const lc = 'views.share_management.';
const formRulesLc = 'form_rules.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const getComp = (n) => ({
            SubscribeHubShareStoreListTable,
            RegisteredShareStoreListTable,
        }[n]);
        const router = useRouter();
        const route = useRoute();
        const getterHubStoreListLength = computed(() => vuexStore.getters['shareManagement/shareConfig/getterHubStoreListLength']);
        const getterRegisteredShareStoreListLength = computed(() => vuexStore.getters['shareManagement/shareConfig/getterRegisteredShareStoreListLength']);
        const getterHubStoreCheckedListLength = computed(() => vuexStore.getters['shareManagement/shareConfig/getterHubStoreCheckedListLength']);
        const getterRegisteredShareStoreCheckedListLength = computed(() => vuexStore.getters['shareManagement/shareConfig/getterRegisteredShareStoreCheckedListLength']);
        const subscribeHubShareStoreListLengthText = computed(() => (getterHubStoreListLength.value === 0 && getterHubStoreCheckedListLength.value === 0
            ? '(0)' : `(${getterHubStoreCheckedListLength.value}/${getterHubStoreListLength.value})`));
        const registeredShareStoreListLengthText = computed(() => (getterRegisteredShareStoreListLength.value === 0 && getterRegisteredShareStoreCheckedListLength.value === 0
            ? '(0)' : `(${getterRegisteredShareStoreCheckedListLength.value}/${getterRegisteredShareStoreListLength.value})`));
        const shareStoreTableComponentList = computed(() => [
            makeComponentInfoList('SubscribeHubShareStoreListTable', `${i18n.t(`${lc}hub_share_store_list`)} ${subscribeHubShareStoreListLengthText.value}`),
            makeComponentInfoList('RegisteredShareStoreListTable', `${i18n.t(`${lc}registered_hub_share_store_list`)} ${registeredShareStoreListLengthText.value}`),
        ]);
        const getterHubStoreSearchOptionField = computed(() => vuexStore.getters['shareManagement/shareConfig/getterHubStoreSearchOptionField']);
        const getterHubStoreSearchOptionValue = computed(() => vuexStore.getters['shareManagement/shareConfig/getterHubStoreSearchOptionValue']);
        const getterRegisteredShareStoreSearchOptionField = computed(() => vuexStore.getters['shareManagement/shareConfig/getterRegisteredShareStoreSearchOptionField']);
        const getterRegisteredShareStoreSearchOptionValue = computed(() => vuexStore.getters['shareManagement/shareConfig/getterRegisteredShareStoreSearchOptionValue']);
        const getterHubStoreList = computed(() => vuexStore.getters['shareManagement/shareConfig/getterHubStoreList']);
        watch(() => getterHubStoreSearchOptionValue.value, (value) => {
            if (!value) {
                // @ts-ignore
                vuexStore.dispatch(shareConfigActionType.setHubStoreList, getterHubStoreList.value);
            }
        });
        watch(() => getterRegisteredShareStoreSearchOptionValue.value, (value) => {
            if (!value) {
                const isDelete = true;
                // @ts-ignore
                vuexStore.dispatch('shareManagement/shareConfig/setRegisteredShareStoreList', {
                    isDelete,
                    tableType: shareStoreTableType.REGISTERED,
                });
            }
        });
        const dispatchSearchOptionAction = (tableType, payload) => {
            const actionPath = tableType === shareStoreTableType.SUBSCRIBE
                ? 'shareManagement/shareConfig/setHubStoreSearchOption'
                : 'shareManagement/shareConfig/setRegisteredShareStoreSearchOption';
            // @ts-ignore
            vuexStore.dispatch(actionPath, payload);
        };
        const handleSearch = (tableType) => (value) => {
            dispatchSearchOptionAction(tableType, {
                value,
            });
        };
        const handleChangeSelect = (tableType) => (selectOptionValue) => {
            if (!selectOptionValue) {
                return;
            }
            dispatchSearchOptionAction(tableType, {
                field: selectOptionValue,
            });
        };
        const getterShareInfoConfig = computed(() => vuexStore.state.shareManagement.shareConfig.shareInfoConfig);
        const getterSubscribeHubId = computed(() => vuexStore.getters['hubSelector/getterSubscribeHubId']);
        const isSubscribeHubShareStoreListTable = (componentName) => componentName === 'SubscribeHubShareStoreListTable';
        const isSubscribeHubShareStoreListButtonDisabled = computed(() => getterHubStoreListLength.value === 0 || getterHubStoreCheckedListLength.value === 0);
        const isRegisteredShareStoreListButtonDisabled = computed(() => getterRegisteredShareStoreListLength.value === 0 || getterRegisteredShareStoreCheckedListLength.value === 0);
        const formRules = createShareInfoConfigFormRules(formRulesLc);
        const formRef = ref(null);
        // const createdFormData = createFormData();
        // const createdOriginFormData = createFormData();
        // const formData = reactive(createdFormData);
        const formData = computed(() => vuexStore.state.shareManagement.shareConfig.formData);
        // const originFormData = reactive(createdOriginFormData);
        const originFormData = computed(() => vuexStore.state.shareManagement.shareConfig.originFormData);
        /** 신규인지 설정한 적 있는지 판단 여부 */
        const isConfigBefore = ref(false);
        const _resetValidation = () => formRef.value?.resetValidation();
        const resetForm = () => {
            _resetValidation();
            // @ts-ignore
            vuexStore.dispatch('shareManagement/shareConfig/resetShareInfoConfig');
        };
        /**
             * 폼 초기화
             */
        const initFormData = (isInitOriginFormData = false) => {
            isConfigBefore.value = false;
            const data = isInitOriginFormData ? originFormData.value : formData.value;
            const newFormData = createFormData();
            Object.entries(getterShareInfoConfig.value ?? {}).reduce((acc, [key, value,]) => {
                const replacedKey = key.replace('_', '');
                // 공유 상점 목록의 경우 getterRegisteredShareStoreList에서 관리하므로 formData에 추가하지 않는다
                if (replacedKey === 'stores') {
                    if (value.length > 0) {
                        // 상점 리스트가 있다면 설정한 적 있는 것으로 판단
                        isConfigBefore.value = true;
                    }
                    return acc;
                }
                if (value === null) {
                    acc[replacedKey] = newFormData[replacedKey];
                    return acc;
                }
                if (replacedKey === 'hubId') {
                    // 페이지 최초 진입 시 getShareInfoConfig 응답 api에 과거 설정 내역이 없는 경우 hubId가 undefined이므로 임의로 params 값 추가하기
                    const { agencyHubId } = route.params;
                    acc.agencyHubId = formData.value.agencyHubId ?? agencyHubId;
                    return acc;
                }
                acc[replacedKey] = value;
                return acc;
            }, data);
        };
        const getterCurrentShareInfoConfigStoreList = computed(() => vuexStore.getters[shareConfigGetterType.getterCurrentShareInfoConfigStoreList]);
        const getterCurrentRegisteredShareStoreInfoList = computed(() => vuexStore.getters[shareConfigGetterType.getterCurrentRegisteredShareStoreInfoList]);
        /**
             * 리스트와 폼 데이터 비교
             */
        const compareOriginWithFormData = () => {
            const isInitOriginFormData = true;
            initFormData(isInitOriginFormData);
            const isSameFormData = objDeepCompare(originFormData.value, formData.value);
            const isSameStoreList = objDeepCompare(getterCurrentShareInfoConfigStoreList.value, getterCurrentRegisteredShareStoreInfoList.value);
            return isSameFormData && isSameStoreList;
        };
        const isSaveButtonDisabled = ref(false);
        const isGetShareInfoConfigFetching = ref(true);
        const isGetShareInfoConfigError = ref(false);
        /**
             * 수주 허브 변경시 신규 데이터 조회
             */
        const changeAgencyHub = async (agencyHubId) => {
            try {
                isGetShareInfoConfigFetching.value = true;
                isGetShareInfoConfigError.value = false;
                await vuexStore.dispatch(shareConfigActionType.getShareInfoConfig, agencyHubId);
            }
            catch (error) {
                if (error instanceof BusinessError) {
                    isGetShareInfoConfigError.value = true;
                    vuexStore.dispatch(snackbarActionType.showError, {
                        message: error.reason ? error.message : 'common.unknown_error',
                    });
                }
            }
            finally {
                isSaveButtonDisabled.value = false;
                isGetShareInfoConfigFetching.value = false;
                initFormData();
            }
        };
        const initPage = async () => {
            // browser reset 시 mounted 시에 값이 없음, 이때는 watch에서 initPage 실행
            if (!getterSubscribeHubId.value) {
                return;
            }
            const { agencyHubId } = route.params;
            changeAgencyHub(agencyHubId);
            try {
                vuexStore.dispatch(shareConfigActionType.selectedShareHubId, agencyHubId);
                // 발주 허브 소속 상점 목록 불러오기
                // @ts-ignore
                // await vuexStore.dispatch('shareManagement/shareConfig/getHubStoreList');
                await vuexStore.dispatch(shareConfigActionType.getHubStoreList);
                // @ts-ignore
                await vuexStore.dispatch('app/setPageTitle');
                // @ts-ignore
                await vuexStore.dispatch('hubSelector/getHubs');
            }
            catch (error) {
                let message = '';
                if (error instanceof CanceledError) {
                    message = error.message;
                }
                console.log('[ShareConfig/index:initPage]', message);
            }
        };
        watch(() => getterSubscribeHubId.value, (value) => {
            if (!value) {
                return;
            }
            initPage();
        });
        const goToDetailPage = () => {
            router.push({
                name: routeName.SHARE_MANAGEMENT,
                query: route.query,
            });
        };
        const isFormValid = () => {
            if (!isConfigBefore.value
                && getterRegisteredShareStoreListLength.value === 0) {
                // @ts-ignore
                vuexStore.dispatch(snackbarActionType.showError, {
                    message: i18n.t(`${lc}no_storeIds_to_create_share_config_error`),
                });
                return false;
            }
            return formRef.value?.validate();
        };
        // eslint-disable-next-line consistent-return
        const _onSubmit = async () => {
            try {
                isSaveButtonDisabled.value = true;
                const postResponse = await vuexStore.dispatch(shareConfigActionType.postShareInfoConfig, {
                    hubId: getterSubscribeHubId.value,
                    shareInfo: formData.value,
                });
                if (!postResponse.isSuccess) {
                    if (postResponse?.reason || postResponse.message) {
                        // @ts-ignore
                        return vuexStore.dispatch(snackbarActionType.showError, {
                            message: errorCode[postResponse?.reason] || postResponse.message,
                        });
                    }
                    // @ts-ignore
                    return vuexStore.dispatch(snackbarActionType.showError, {
                        message: i18n.t('common.unknown_error'),
                    });
                }
                // @ts-ignore
                vuexStore.dispatch(snackbarActionType.showSuccess, {
                    message: i18n.t(isConfigBefore.value
                        ? 'views.snackbar.share_config_modify_complete'
                        : 'views.snackbar.share_config_create_complete'),
                });
                isConfigBefore.value = getterRegisteredShareStoreListLength.value > 0;
                changeAgencyHub(formData.value.agencyHubId);
            }
            catch (error) {
                return console.log('[shareConfig onSubmit error]', error);
            }
        };
        const handleSubmitForm = () => {
            const isValid = isFormValid();
            if (!isValid) {
                return;
            }
            _onSubmit();
        };
        /**
             * 페이지 이탈
             */
        const handleClickList = async () => {
            const isSame = compareOriginWithFormData();
            if (isSame) {
                goToDetailPage();
                return;
            }
            const isConfirmOk = await vuexStore.dispatch(shareConfigActionType.checkOriginData);
            if (isConfirmOk) {
                goToDetailPage();
            }
        };
        const handleClickAddShareStore = () => {
            const isDelete = false;
            // @ts-ignore
            vuexStore.dispatch('shareManagement/shareConfig/setRegisteredShareStoreList', {
                isDelete,
                tableType: shareStoreTableType.SUBSCRIBE,
            });
        };
        const handleClickDeleteShareStore = () => {
            const isDelete = true;
            // @ts-ignore
            vuexStore.dispatch('shareManagement/shareConfig/setRegisteredShareStoreList', {
                isDelete,
                tableType: shareStoreTableType.REGISTERED,
            });
        };
        const localeInfo = {
            backToButtonText: i18n.t('common.back_to_list'),
            saveButtonText: i18n.t('common.save'),
            addShareStoreButtonText: i18n.t(`${lc}add_share_store`),
            deleteShareStoreButtonText: i18n.t(`${lc}delete_share_store`),
            searchPlaceholder: i18n.t('common.input_field_placeholder', {
                field: i18n.t('common.search_word'),
            }),
        };
        const getterShareInfoConfigHubId = computed(() => vuexStore.getters[shareConfigGetterType.getterShareInfoConfigHubId]);
        // 허브 변경시 데이터 업데이트
        watch(() => formData.value.agencyHubId, (value) => {
            if (value
                && getterShareInfoConfigHubId.value
                && value !== getterShareInfoConfigHubId.value) {
                changeAgencyHub(value);
            }
        });
        onMounted(() => {
            initPage();
            const { agencyHubId } = route.params;
            vuexStore.dispatch(shareConfigActionType.setFormValue, [
                'agencyHubId',
                agencyHubId,
            ]);
        });
        onBeforeUnmount(() => {
            resetForm();
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_form = _resolveComponent("v-form");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_form, {
                    class: "form-wrapper",
                    ref_key: "formRef",
                    ref: formRef
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shareStoreTableComponentList.value, ({ componentName, title }, key) => {
                                return (_openBlock(), _createBlock(CardSection, {
                                    key: key,
                                    title: title,
                                    class: "table-content-wrapper",
                                    m0: ""
                                }, {
                                    titleContent: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_3, [
                                            _createCommentVNode(" 공유 상점 추가 "),
                                            (isSubscribeHubShareStoreListTable(componentName))
                                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                                    key: 0,
                                                    class: "brg-btn info outlined size-m",
                                                    disabled: isSubscribeHubShareStoreListButtonDisabled.value,
                                                    onClick: handleClickAddShareStore
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, null, {
                                                            default: _withCtx(() => _cache[0] || (_cache[0] = [
                                                                _createTextVNode("mdi-plus")
                                                            ])),
                                                            _: 1 /* STABLE */,
                                                            __: [0]
                                                        }),
                                                        _createElementVNode("span", null, _toDisplayString(localeInfo.addShareStoreButtonText), 1 /* TEXT */)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["disabled"]))
                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createCommentVNode(" 공유 상점 삭제 "),
                                                    _createVNode(_component_v_btn, {
                                                        class: "brg-btn info outlined size-m",
                                                        disabled: isRegisteredShareStoreListButtonDisabled.value,
                                                        onClick: handleClickDeleteShareStore
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_icon, null, {
                                                                default: _withCtx(() => _cache[1] || (_cache[1] = [
                                                                    _createTextVNode(" mdi-trash-can-outline ")
                                                                ])),
                                                                _: 1 /* STABLE */,
                                                                __: [1]
                                                            }),
                                                            _createElementVNode("span", null, _toDisplayString(localeInfo.deleteShareStoreButtonText), 1 /* TEXT */)
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["disabled"])
                                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                        ])
                                    ]),
                                    default: _withCtx(() => [
                                        (isSubscribeHubShareStoreListTable(componentName))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                _createVNode(Select, {
                                                    class: "select-wrapper",
                                                    style: { "width": "120px" },
                                                    value: getterHubStoreSearchOptionField.value,
                                                    items: _unref(searchFieldOptionList),
                                                    "on-change": handleChangeSelect(_unref(shareStoreTableType).SUBSCRIBE)
                                                }, null, 8 /* PROPS */, ["value", "items", "on-change"]),
                                                _createVNode(SearchInput, {
                                                    class: "search-value-input",
                                                    outlined: "",
                                                    placeholder: localeInfo.searchPlaceholder,
                                                    "on-search": handleSearch(_unref(shareStoreTableType).SUBSCRIBE),
                                                    "default-value": getterHubStoreSearchOptionValue.value
                                                }, null, 8 /* PROPS */, ["placeholder", "on-search", "default-value"])
                                            ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                                _createVNode(Select, {
                                                    class: "select-wrapper",
                                                    style: { "width": "120px" },
                                                    value: getterRegisteredShareStoreSearchOptionField.value,
                                                    items: _unref(searchFieldOptionList),
                                                    "on-change": handleChangeSelect(_unref(shareStoreTableType).REGISTERED)
                                                }, null, 8 /* PROPS */, ["value", "items", "on-change"]),
                                                _createVNode(SearchInput, {
                                                    class: "search-value-input",
                                                    outlined: "",
                                                    placeholder: localeInfo.searchPlaceholder,
                                                    "on-search": handleSearch(_unref(shareStoreTableType).REGISTERED),
                                                    "default-value": getterRegisteredShareStoreSearchOptionValue.value
                                                }, null, 8 /* PROPS */, ["placeholder", "on-search", "default-value"])
                                            ])),
                                        (_openBlock(), _createBlock(_resolveDynamicComponent(getComp(componentName)), {
                                            "is-fetching": isGetShareInfoConfigFetching.value,
                                            "is-error": isGetShareInfoConfigError.value
                                        }, null, 8 /* PROPS */, ["is-fetching", "is-error"]))
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title"]));
                            }), 128 /* KEYED_FRAGMENT */)),
                            _createCommentVNode(" 공유설정, 수수료 비율 "),
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(CardSection, {
                                    title: _unref(i18n).t(`${lc}share_config`),
                                    class: "basic"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(ShareConfigBasic, {
                                            "form-rules": _unref(formRules),
                                            lc: lc
                                        }, null, 8 /* PROPS */, ["form-rules"])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["title"]),
                                _createVNode(CardSection, {
                                    title: _unref(i18n).t(`${lc}fee_rate`),
                                    class: "rate"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(ShareConfigFeeRate, {
                                            "form-data": formData.value,
                                            "form-rules": _unref(formRules),
                                            lc: lc
                                        }, null, 8 /* PROPS */, ["form-data", "form-rules"])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["title"])
                            ])
                        ]),
                        _createCommentVNode(" 목록보기 "),
                        _createElementVNode("div", _hoisted_7, [
                            _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                class: "mr-2",
                                onClick: handleClickList
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { small: "" }, {
                                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                                            _createTextVNode(" mdi-chevron-left ")
                                        ])),
                                        _: 1 /* STABLE */,
                                        __: [2]
                                    }),
                                    _createElementVNode("span", null, _toDisplayString(localeInfo.backToButtonText), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })), [
                                [
                                    _directive_btn_style,
                                    void 0,
                                    "config",
                                    {
                                        info: true,
                                        outlined: true,
                                        "width-xs": true,
                                        "size-l": true
                                    }
                                ]
                            ]),
                            _createVNode(_component_v_btn, {
                                class: "brg-btn primary width-xs size-l",
                                disabled: isSaveButtonDisabled.value,
                                onClick: handleSubmitForm
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(localeInfo.saveButtonText), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled"])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }, 512 /* NEED_PATCH */)
            ]));
        };
    }
});
